import { useRef } from 'react';
import { InputHistory } from '../input-history';

export function useInputHistory(): InputHistory {
    const historyRef = useRef<InputHistory | null>(null);
    if (historyRef.current === null) {
        historyRef.current = new InputHistory();
    }
    return historyRef.current;
}
